
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 22 22","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cross",attrs:{"fill":"#E31F13","vector-effect":"non-scaling-stroke","d":"M5.181 17.422h2.203l3.633-5.203 3.599 5.203h2.203l-4.699-6.574 4.463-6.27h-2.191L11.017 9.5 7.63 4.578H5.415l4.465 6.27z"}}),_c('path',{staticClass:"outline",attrs:{"d":"M17.667 21H4.333C2.496 21 1 19.43 1 17.5v-13C1 2.57 2.496 1 4.333 1h13.333C19.505 1 21 2.57 21 4.5v13c0 1.93-1.495 3.5-3.333 3.5zM20 4.5C20 3.119 18.934 2 17.619 2H4.381C3.066 2 2 3.119 2 4.5v13C2 18.881 3.066 20 4.381 20h13.238C18.934 20 20 18.881 20 17.5v-13z","fill":"#E31F13","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    